import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/registrars/new/loading';

export const Route = createFileRoute('/_private/settings/registrars/new')({
  component: Loading,
});
